import { isStringNullOrWhiteSpace } from 'owa-localize';
import ShareModal from './ShareModal';
import { closeSharingDialog, openSharingDialog } from '../actions/internalActions';
import getStore from '../store/store';
import { SharingDialogResponse } from '../types/SharingDialogResponse';
import { getDefaultPeoplePickerProvider } from '../utils/getDefaultPeoplePickerProvider';
import { getDefaultSharingProvider } from '../utils/getDefaultSharingProvider';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

let sharingDialogDiv;

export default async function showSharingDialog(
    resolve: (result: SharingDialogResponse) => void,
    reject: () => void,
    webUrl: string,
    canonicalUrl: string,
    shareId: string,
    permissionLevel: AttachmentPermissionLevel
) {
    if (!sharingDialogDiv) {
        // As we can have only one sharing dialog open at a time so we only create the
        // DOM element once and reuse that.
        sharingDialogDiv = document.createElement('div');
        sharingDialogDiv.id = 'sharingDialog';
        document.body.appendChild(sharingDialogDiv);
    }
    const sharingDialogStore = getStore();

    const peoplePickerProvider = await getDefaultPeoplePickerProvider(webUrl);
    const sharingProvider = await getDefaultSharingProvider(webUrl, canonicalUrl);

    // Setting shareId to '' means to use the tenant default link. Setting it to '0000...' means it's the canonical link and "People with existing access" should be highlighted.
    // OWA currently doesn't have a scenario where we would use the tenant default link, since we only open the sharing dialog when there is already an existing link.
    if (isStringNullOrWhiteSpace(shareId)) {
        shareId = '00000000-0000-0000-0000-000000000000';
    }

    const shareProps = {
        peoplePickerProvider: peoplePickerProvider,
        sharingProvider: sharingProvider,
        shareId: shareId,
        permissionLevel: permissionLevel,
    };

    function onDismiss(result?: SharingDialogResponse) {
        closeSharingDialog();
        if (result) {
            resolve(result);
            return;
        }

        reject();
    }

    ReactDOM.render(
        <ShareModal
            shareProps={shareProps}
            sharingDialogStore={sharingDialogStore}
            onDismiss={onDismiss}
        />,
        sharingDialogDiv
    );
    openSharingDialog();
}
